import * as React from 'react';

import { CommonContainer } from '../../styled';

import { RichContentScrollTracker } from './RichContentScrollTracker';
import { Wrapper } from './styled';

export const RichContentContainer: React.FC<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rcComponent: any;
}> = ({ rcComponent }) => {
  if (!rcComponent) {
    return null;
  }

  return (
    <CommonContainer id="pdRichContent">
      <Wrapper>
        {rcComponent}
        <RichContentScrollTracker />
      </Wrapper>
    </CommonContainer>
  );
};
